import { SEARCH_PARAM_ORG_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_WORKFLOW_ID = 'workflowId'
export const SEARCH_PARAM_TICKET = 'ticket'
export const SEARCH_PARAM_THREAD = 'thread'

export const libraSearchParamsSchema = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_WORKFLOW_ID]: z.string().optional(),
  [SEARCH_PARAM_TICKET]: z.string().optional(),
  [SEARCH_PARAM_THREAD]: z.string().optional(),
})

export type LibraSearchParams = z.infer<typeof libraSearchParamsSchema>

export function createLibraSearch({
  orgId,
  workflowId,
  ticket,
  thread,
}: LibraSearchParams): LibraSearchParams {
  return {
    [SEARCH_PARAM_ORG_ID]: orgId,
    [SEARCH_PARAM_WORKFLOW_ID]: workflowId,
    [SEARCH_PARAM_TICKET]: ticket,
    [SEARCH_PARAM_THREAD]: thread,
  }
}

export function createLibraUrl(searchParams: LibraSearchParams): string {
  const search = new URLSearchParams()

  for (const [key, value] of Object.entries(createLibraSearch(searchParams))) {
    if (value !== undefined) {
      search.set(key, value)
    }
  }

  const query = search.toString()

  return query ? `/libra?${query}` : '/libra'
}
